import { getItemPath } from "src/utils/getItemPath";
import { ReactComponent as FileIcon } from "src/assets/icons/file.svg";
import { ReactComponent as SpiralIcon } from "src/assets/icons/spiral.svg";
import { ReactComponent as InquiriesIcon } from "src/assets/icons/inquiries-outline.svg";
import { PATHNAMES } from "src/constants/routes";
import { ISidebarItem } from "src/components/NavigationSidebar/types";
import { tabsTrns } from "../trns";

export const NAVIGATION_SIDEBAR_ITEMS = (
  idWithSlug: string,
  role?: string
): ISidebarItem[] => {
  const items: ISidebarItem[] = [
    {
      id: "1",
      href: getItemPath(PATHNAMES.USER_PROFILE, { id: idWithSlug }),
      title: { i18nKey: tabsTrns.profile },
      icon: FileIcon,
    },
    {
      id: "2",
      href: getItemPath(PATHNAMES.USER_PROFILE_CLONES, { id: idWithSlug }),
      title: { i18nKey: tabsTrns.clones },
      icon: SpiralIcon,
    },
  ];

  if (role === "agent") {
    items.push({
      id: "3",
      href: getItemPath(PATHNAMES.USER_PROFILE_INQUIRIES, { id: idWithSlug }),
      title: { i18nKey: tabsTrns.inquiries },
      icon: InquiriesIcon,
    });
  }

  return items;
};
